/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import {
  Card,
  CardContent,
  Paper,
  Typography,
} from '@material-ui/core';
import Lightbox from 'react-image-lightbox';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import SiteAssignRow from './SiteAssignRow';
import {
  approveRejectSiteReport,
  createNewTask,
  notifyMonitor,
  updateSiteLinkForReport,
} from '../../redux/actions/sites';
import FallbackCard from '../../CommonComponents/FallbackCard';
import 'react-image-lightbox/style.css';
import { CommonCarousel, CommonModal, CommonSelect } from '../../CommonComponents';
import SiteCarouselSlide from '../SiteAssign/SiteCarouselSlide';

const headCells = [
  {
    id: 'siteId',
    numeric: false,
    disablePadding: true,
    label: 'Site Code',
  },
  {
    id: 'startDate',
    numeric: false,
    disablePadding: true,
    label: 'Duration',
  },
  {
    id: 'mediaType',
    numeric: true,
    disablePadding: false,
    label: 'Media',
  },
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'locationName',
    numeric: true,
    disablePadding: false,
    label: 'Location',
  },
  {
    id: 'stateName',
    numeric: true,
    disablePadding: false,
    label: 'State',
  },
  {
    id: 'supplierName',
    numeric: true,
    disablePadding: false,
    label: 'Vendor',
  },
  {
    id: 'sizeInfo',
    numeric: true,
    disablePadding: false,
    label: 'Size Info',
  },
  {
    id: 'campaignDescription',
    numeric: true,
    disablePadding: false,
    label: 'Campaign',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  right: {
    float: 'right',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    float: 'right',
    marginLeft: 20,
    width: 200,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
  accordion: {
    boxShadow: 'none',
    display: 'block',
    padding: 0,
  },
  detailBtn: {
    marginLeft: 'auto',
    fontWeight: 'bold',
    marginTop: '4px',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#bdbdbd',
    justifyContent: 'center',
    alignContent: 'center',
    alignSelf: 'center',
  },
  cancel: {
    position: 'absolute',
    top: 5,
    right: 10,
    zIndex: 1,
    color: '#fff',
  },
  pointer: {
    cursor: 'pointer',
  },
  noImage: {
    backgroundColor: '#333333',
    textAlign: 'center',
  },
}));

const SiteAssignTable = ({
  allSites, handleFilter,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId')
  const [modalOpen, setModalOpen] = useState(false);
  const [siteToView, setSiteToView] = useState(null);
  const [site, setSite] = useState(null);
  const [carousels, setCarousels] = useState([]);
  const [lightbox, setLightbox] = useState([]);
  const [showLighBox, openLightBox] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleViewDetails = (row, item) => {
    setSite(row);
    setSiteToView(item);
    const siteData = [];
    const lighboxArr = [];
    if (item) {
      siteData.push({ url: item.imageUrl, type: item.imageUrl.includes('.mp4?sv') ? 'video' : 'image', status: '' });
      lighboxArr.push(item.imageUrl);
      setCarousels(siteData);
      setLightbox(lighboxArr);
    }
    setModalOpen(true);
  };

  const openLighBoxModal = (index) => {
    setPhotoIndex(index);
    openLightBox(true);
  };

  const handleDismissModal = () => {
    setSiteToView({});
    setModalOpen(false);
  };

  return (
    <div className={classes.root}>
      <div className="row">
        <div className="col-3">
          <CommonSelect
            label="Filter by Status"
            options={[{
              text: 'Pending',
              value: 'pending',
            },
            {
              text: 'Approved',
              value: 'approved',
            },
            {
              text: 'Rejected',
              value: 'rejected',
            },
            {
              text: 'Review Requested',
              value: 'requestedReview',
            }]}
            handleChange={(e) => handleFilter(e)}
          />
        </div>
      </div>
      {allSites.length > 0 ? (
        <div>
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={allSites.length}
                  checkbox
                />
                <TableBody>
                  {stableSort(allSites, getComparator(order, orderBy))
                    .map((row) => (
                      <SiteAssignRow
                        key={row.id}
                        row={row}
                        handleViewDetails={handleViewDetails}
                      />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}

      {modalOpen && (
      <CommonModal
        open
        width="md"
        padded={false}
        onClose={() => {
          handleDismissModal();
        }}
        cancelButtonText="Reject"
        successButtonText="Approve"
        hideActionbuttons
      >
        <Card>
          {carousels.length > 0 ? (
            <CommonCarousel>
              {carousels.map((media, index) => (
                <SiteCarouselSlide
                  index={index}
                  key={siteToView.id}
                  media={media}
                  approvedMedia={siteToView.approvedUrl}
                  openLightBox={openLighBoxModal}
                />
              ))}
            </CommonCarousel>
          ) : (
            <CardContent className={classes.noImage}>
              <Typography style={{ color: '#fff', fontWeight: 'bold' }}>
                No image found
              </Typography>
            </CardContent>
          )}
          <CardContent>
            <div className="row">
              <div className="col-12">
                <div>
                  <b>Location :-</b>
                  {' '}
                  {site.locationName}
                  {', '}
                  {site.cityName}
                  {', '}
                  {site.stateName}
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-5">
                    <b>Media Type :-</b>
                    {' '}
                    {site.mediaTypeName}
                    <br />
                    <b>Latitude :-</b>
                    {' '}
                    {siteToView.latitude}
                    <br />
                    <b>Longitude :-</b>
                    {' '}
                    {siteToView.longitude}
                  </div>
                  <div className="col-7" />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </CommonModal>
      )}

      {showLighBox && lightbox.length > 0 && (
      <Lightbox
        mainSrc={lightbox[photoIndex]}
        nextSrc={lightbox[(photoIndex + 1) % lightbox.length]}
        prevSrc={
            lightbox[(photoIndex + lightbox.length - 1) % lightbox.length]
          }
        onMovePrevRequest={() => setPhotoIndex((photoIndex + lightbox.length - 1) % lightbox.length)}
        onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % lightbox.length)}
        onCloseRequest={() => openLightBox(false)}
      />
      )}

    </div>
  );
};

const mapState = (state) => ({
  allSites: state.common.sitesOfAuditorDashboard,
});

const mapActions = {
  approveRejectSite: approveRejectSiteReport,
  notify: notifyMonitor,
  updateSiteReportLink: updateSiteLinkForReport,
  createNTask: createNewTask,
};

export default connect(mapState, mapActions)(SiteAssignTable);
